(function(){
  if(window.__tamHsInit) return; window.__tamHsInit=true;
  document.documentElement.classList.add('tam-js');
  function reveal(){
    var els=document.querySelectorAll('.tam-reveal:not(.in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:"0px 0px -40px 0px"});
    els.forEach(function(e){io.observe(e)});
  }
  function faq(){
    document.querySelectorAll('.tam-faq__q').forEach(function(btn){
      if(btn.__b) return; btn.__b=true;
      btn.addEventListener('click',function(){
        var item=btn.closest('.tam-faq__item');
        var a=item.querySelector('.tam-faq__a');
        var open=item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open?'true':'false');
        a.style.maxHeight= open ? a.firstElementChild.scrollHeight+'px' : '0px';
      });
    });
  }
  function beforeAfter(){
    document.querySelectorAll('.tam-ba__range').forEach(function(range){
      if(range.__b) return; range.__b=true;
      var wrap=range.closest('.tam-ba');
      if(!wrap) return;
      var set=function(){ wrap.style.setProperty('--tam-ba-pos', range.value+'%'); };
      range.addEventListener('input',set);
      set();
    });
  }
  function carousel(){
    document.querySelectorAll('[data-tam-carousel]').forEach(function(root){
      if(root.__b) return; root.__b=true;
      var track=root.querySelector('.tam-tc__track');
      var items=[].slice.call(root.querySelectorAll('.tam-tc__item'));
      if(!track||!items.length) return;

      var ticking=false;
      var mark=function(){
        ticking=false;
        var mid=track.scrollLeft+track.clientWidth/2;
        var best=null, bestD=Infinity;
        items.forEach(function(el){
          var c=el.offsetLeft+el.offsetWidth/2;
          var d=Math.abs(c-mid);
          if(d<bestD){bestD=d;best=el;}
        });
        items.forEach(function(el){
          el.classList.remove('is-center','is-left','is-right');
          if(el===best){el.classList.add('is-center');return;}
          var c=el.offsetLeft+el.offsetWidth/2;
          el.classList.add(c<mid?'is-left':'is-right');
        });
      };
      var onScroll=function(){ if(!ticking){ticking=true;requestAnimationFrame(mark);} };
      track.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll);

      var step=function(dir){
        var w=items[0].offsetWidth+parseFloat(getComputedStyle(track).columnGap||'20');
        track.scrollBy({left:dir*w,behavior:'smooth'});
      };
      var prev=root.querySelector('.tam-tc__nav--prev');
      var next=root.querySelector('.tam-tc__nav--next');
      if(prev) prev.addEventListener('click',function(){step(-1)});
      if(next) next.addEventListener('click',function(){step(1)});

      // start op het middelste item, zodat de rij meteen gevuld oogt
      var start=items[Math.floor((items.length-1)/2)];
      if(start) track.scrollLeft=start.offsetLeft+start.offsetWidth/2-track.clientWidth/2;
      mark();
    });
  }
  function run(){reveal();faq();beforeAfter();carousel();}
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();
